// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"5493b22b","239":"e39fb35b","455":"b0748933","977":"f49d09dd","989":"6010d595"}[chunkId] + ".chunk.js";
};